import React from 'react'
import { WidgetId } from 'features/types'
import { useDashboardWidgetData, useDashboardWidgetPreWork } from 'hooks/useWidgetState'
import { DocumentRetrievalResult } from 'schemas/DocumentRetrievalResultSchema'
import { SentenceRetrievalResult } from 'schemas/SentenceRetrievalResultSchema'
import { DocumentFingerprintRetrievalResult } from 'schemas/DocumentFingerprintRetrievalResultSchema'
import { SentenceFingerprintRetrievalResult } from 'schemas/SentenceFingerprintRetrievalResultSchema'
import LoadMoreButton from 'components/visualization/SoundbiteFrame/LoadMore/LoadMoreButton'
import LoadingIcon from 'components/visualization/SoundbiteFrame/LoadMore/LoadingIcon'
import CountType from 'enums/CountType'
import DocumentSoundbiteStreamFactory from './DocumentSoundbiteStreamFactory'
import SentenceSoundbiteStreamFactory from './SentenceSoundbiteStreamFactory'
import { useWidgetSettingContext } from '../widgetSettingContext'

const getLoadIcon = (isDataReady: boolean, hasMoreSoundbites: boolean, callback: () => void) => {
  if (!isDataReady) {
    return <LoadingIcon />
  }

  if (hasMoreSoundbites) {
    return <LoadMoreButton callback={callback} />
  }

  return undefined
}

type StreamProps = {
  widgetId: WidgetId
  fingerprintIndex: number
  callback: () => void
}

const Stream = ({ widgetId, fingerprintIndex, callback }: StreamProps): React.ReactElement => {
  const preWork = useDashboardWidgetPreWork<
    DocumentFingerprintRetrievalResult | SentenceFingerprintRetrievalResult
  >(widgetId)
  const { fingerprints } = preWork[0].results![0].data

  const widgetData = useDashboardWidgetData<DocumentRetrievalResult | SentenceRetrievalResult>(
    widgetId
  )

  const { countType, maxSoundbites } = useWidgetSettingContext()

  const isDataReady = widgetData.loadMoreStatus === 'succeeded'
  const hasMoreSoundbites = fingerprints!.length > fingerprintIndex + maxSoundbites!

  return (
    <>
      {widgetData.data.map((data, index) =>
        countType === CountType.POSTS ? (
          <DocumentSoundbiteStreamFactory
            widgetId={widgetId}
            widgetData={data}
            key={data.lastUpdateTime}
            batch={index}
          />
        ) : (
          <SentenceSoundbiteStreamFactory
            widgetId={widgetId}
            widgetData={data}
            key={data.lastUpdateTime}
            batch={index}
          />
        )
      )}
      {getLoadIcon(isDataReady, hasMoreSoundbites, callback)}
    </>
  )
}

export default Stream
